import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import React from 'react';
import { useTranslation } from 'react-i18next';
import VisuallyHidden from 'components/VisuallyHidden';
import { ContentCardButton } from 'components/ContentCards';
import getBasicDate from 'utils/dates/getBasicDate';
import { jsxs as _jsxs } from "react/jsx-runtime";
export function MeetingLink(_ref) {
  var eventSession = _ref.eventSession,
    assetName = _ref.assetName;
  var _useTranslation = useTranslation(),
    _useTranslation2 = _slicedToArray(_useTranslation, 1),
    t = _useTranslation2[0];
  var linkUrl = eventSession.linkUrl,
    status = eventSession.status,
    startDateTime = eventSession.startDateTime;
  var todayString = getBasicDate(new Date());
  var startString = getBasicDate(new Date(startDateTime));
  var showMeetingLink = status === 'booked' && linkUrl && startString === todayString;
  if (!showMeetingLink) {
    return null;
  }
  return /*#__PURE__*/_jsxs(ContentCardButton, {
    as: "a",
    href: "/api/url?url=".concat(encodeURIComponent(linkUrl)),
    target: "_blank",
    rel: "noopener noreferrer",
    icon: "external",
    children: [t('actions_join_meeting'), /*#__PURE__*/_jsxs(VisuallyHidden, {
      children: [" ", assetName]
    })]
  });
}
export default MeetingLink;